<template>
  <div class="hero section-type-s bground-config-clean presentation">
  <br />
  <br />
  <br />
  <br />
  <br />
  <br />
  <br />
  <br />
  <main class="container fonfoBlanco">
    <div class="mb-4 text-white rounded bg-dark">
      <div class="col-md-12">
        <img src="https://www.chevrolet.com.co/content/dam/chevrolet/south-america/colombia/espanol/index/servicios/colision/mastehad-colision.jpg?imwidth=1800" style="width: 100%;">
      </div>
    </div>

    <div class="col-md-12 mb-5">
     <div class="container mx-auto text-center">
        <h1 class="mt-5 ">Tener tu Chevrolet al día, no es una decisión a la ligera.</h1>
      </div>
    </div>

     <div class="mb-4 text-white rounded bg-dark">
      <div class="col-md-12">
        <img src="https://www.chevrolet.com.co/content/dam/chevrolet/south-america/colombia/espanol/index/servicios/colision/img-servicio-posventa-colision.jpg?imwidth=1800" style="width: 100%;">
      </div>
    </div>

    <div class="row py-lg-5">
      <div class="col-lg-6 col-md-8 mx-auto">
        <h1 class="fw-light "> Servicio posventa Chevrolet Colisión </h1>
      </div>
    </div>
    <div class="row py-lg-5">
      <div class="col-lg-6 col-md-8 mx-auto">
        <h5 class="fw-light "> ¿QUÉ HACER EN CASO DE TENER UNA COLISIÓN?  </h5>
        <h1 class="lead text-muted">En cada paso estamos a tu lado.</h1>
      </div>
    </div>
    <div class="row g-5 py-5">
    <div class="feature col-md-4">
      <div class="feature-icon bg-primary bg-gradient">
       <img class="img-thumbnail" src="https://www.chevrolet.com.co/content/dam/chevrolet/south-america/colombia/espanol/index/servicios/colision/02-images/paso-1-colision.jpg?imwidth=628">
      </div>
      <p class="">Contáctate con la compañía de seguros donde tienes afiliado tu vehículo.</p>
    </div>
    <div class="feature col-md-4">
      <div class="feature-icon bg-primary bg-gradient">
       <img class="img-thumbnail" src="https://www.chevrolet.com.co/content/dam/chevrolet/south-america/colombia/espanol/index/servicios/colision/02-images/paso-2-colision.jpg?imwidth=628">
      </div>
      <p class="">Ellos analizarán la cobertura del siniestro y el amparo de la póliza.</p>
    </div>
    <div class="feature col-md-4">
      <div class="feature-icon bg-primary bg-gradient">
       <img class="img-thumbnail" src="https://www.chevrolet.com.co/content/dam/chevrolet/south-america/colombia/espanol/index/servicios/colision/02-images/paso-3-colision.jpg?imwidth=628">
      </div>
      <p class="">Debes trasladar el vehículo solo a un concesionario de la red autorizada Chevrolet.</p>
    </div>
    <div class="feature col-md-4">
      <div class="feature-icon bg-primary bg-gradient">
       <img class="img-thumbnail" src="https://www.chevrolet.com.co/content/dam/chevrolet/south-america/colombia/espanol/index/servicios/colision/02-images/paso-4-colision.jpg?imwidth=628">
      </div>
      <p class="">La aseguradora te entregará de forma escrita la solicitud de los documentos, para formalizar la reclamación.</p>
    </div>
    <div class="feature col-md-4">
      <div class="feature-icon bg-primary bg-gradient">
       <img class="img-thumbnail" src="https://www.chevrolet.com.co/content/dam/chevrolet/south-america/colombia/espanol/index/servicios/colision/02-images/paso-5-colision.jpg?imwidth=628">
      </div>
      <p class="">Cuando tu vehículo esté en el taller autorizado, valoraremos los daños y solicitaremos los repuestos que sean necesarios, además entregaremos la cotización de los repuestos y la mano de obra que debe cancelar tu aseguradora..</p>
    </div>
     <div class="feature col-md-4">
      <div class="feature-icon bg-primary bg-gradient">
       <img class="img-thumbnail" src="https://www.chevrolet.com.co/content/dam/chevrolet/south-america/colombia/espanol/index/servicios/colision/02-images/paso-6-colision.jpg?imwidth=628">
      </div>
      <p class=""> Una vez esté autorizada la reparación, iniciaremos el proceso.</p>
    </div>
    </div>
  </main>
   <br />
    <br />
    <br />
    <br />
    <br />
    <br />
    <br />
    <br />
  </div>
</template>

<script>
export default {
  name: 'Nosotros'
}
</script>

<style scoped>
  .nav-tabs .nav-item.show .nav-link, .nav-tabs .nav-link.active {
      background-color: #313667;
      border-color: #dee2e600;
  }
  .fonfoBlanco {
    background: url(https://www.toptal.com/designers/subtlepatterns/patterns/interlaced.png);
    padding-top: 16px;
    padding-bottom: 16px;
  }

</style>
